import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { CurrencyConverter } from '@logio/common-be-fe';
import { GenericTransportLayer } from '../GenericTransportLayer';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
export var CurrencyLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(CurrencyLayer, _GenericTransportLaye);

  function CurrencyLayer() {
    _classCallCheck(this, CurrencyLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(CurrencyLayer).call(this, CONSTANTS.API.ENDPOINTS.CURRENCY));
  }

  _createClass(CurrencyLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }]);

  return CurrencyLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", CurrencyConverter)], CurrencyLayer.prototype, "converter", void 0);